import * as React from 'react'
import { useSelector } from 'react-redux'

import './styles.scss'
import ToggleSwitch from './ToggleSwitch'
import { lang } from 'utils/helpers'
import flagEnvDisplay from 'constants/flagEnvDisplay'

const NotificationsCard = ({ generalList, assignedList, inChat, setChecked }) => {
  const { inchat } = useSelector(store => store.modules)

  return (
    <div className='notifications-card'>
      <div className='title-section'>
        <p className='title'>
          {lang('dashboard_notifications')}
        </p>
        <p className='subtitle'>
          {lang('notifications_view_pool_card_subtitle')}
        </p>
      </div>
      <div className='options-section'>
        <ToggleSwitch
          checked={!!generalList}
          onChange={({ value }) => setChecked({ fieldName: 'generalList', fieldValue: value })}
          switchTitle={lang('dashboard_pool-general')}
          switchSubtitle={lang('notifications_view_pool_card_main_toggle_subtitle')}
        />
        <ToggleSwitch
          checked={!!assignedList}
          onChange={({ value }) => setChecked({ fieldName: 'assignedList', fieldValue: value })}
          switchTitle={`${lang('dashboard_pool-personal')} (${lang('dashboard_assigned-plural')})`}
          switchSubtitle={lang('notifications_view_pool_card_assigned_toggle_subtitle')}
        />
        {
          inchat.isActive && flagEnvDisplay.displayInChat ? (
            <ToggleSwitch
              checked={!!inChat}
              onChange={({ value }) => setChecked({ fieldName: 'inChat', fieldValue: value })}
              switchTitle={lang('dashboard_inchat')}
              switchSubtitle={lang('notifications_view_pool_card_inchat_toggle_subtitle')}
            />
          ) : null
        }
      </div>
    </div>
  )
}

export default NotificationsCard
